import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  fieldWrapper: {
    marginTop: '35px',
  },
  cardStyle: {
    padding: '20px',
    maxWidth: '350px',
    width: '350px',
  },
  actionsWrapper: {
    justifyContent: 'flex-end',
  },
  actionBtn: {
    marginLeft: 16,
    padding: '11px 33px',
  },
  cardHeaderStyle: {
    '& .MuiCardHeader-title': {
      fontSize: 18,
    },
  },
}))
